import type { ActionDispatch, PropsWithChildren } from "react";
import { useCallback } from "react";
import { BiCommonDataContextProvider } from "../../../contexts/BiCommonDataContextProvider.tsx";
import { useAppDispatch } from "../../../store/hooks/useAppDispatch";
import { createCurrentReportAction } from "../../../store/utils/storeUtils";
import useViewReportHandlers from "../../viewer/common/hooks/useViewReportHandlers.ts";
import type { RunState, RunStateAction } from "../../viewer/storage/runState.ts";
import useSelectCommonData from "./hooks/useSelectCommonData";

interface Props {
  runState: RunState;
  dispatchRunState: ActionDispatch<[action: RunStateAction]>;
}
const ViewCommonDataProvider = ({ children, dispatchRunState, runState }: PropsWithChildren<Props>) => {
  const viewHandlers = useViewReportHandlers(dispatchRunState);
  const commonData = useSelectCommonData(runState);
  const dispatch = useAppDispatch();
  const onRefreshGrid = useCallback(() => {
    dispatch(createCurrentReportAction("refresh"));
  }, [dispatch]);

  return (
    <BiCommonDataContextProvider
      onRefreshGrid={onRefreshGrid}
      {...commonData}
      onConditionUpdate={viewHandlers.handleConditionUpdate}
      dimensionNames={runState.dimensionNames}
      measureNames={runState.measureNames}
      dataSetId={runState.dataSetId}
      conditions={runState.conditions}
      editMode={false}
      onFieldWithCustomConditionUpdate={viewHandlers.handleFieldUpdate}
      onSortingUpdate={viewHandlers.handleSortingUpdate}
    >
      {children}
    </BiCommonDataContextProvider>
  );
};

export default ViewCommonDataProvider;
